import clsx from 'clsx';
import Skeleton, { type SkeletonProps } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import type { Spacing } from '@commons/types/styles';

/**
 * Loading skeleton component props.
 */

export type LoadingSkeletonProps = SkeletonProps & {
  marginBottom?: Spacing | number;
};

/**
 * Loading skeleton component.
 *
 * Useful when fetching data from an API and you need to show a loading state.
 *
 * @see https://github.com/dvtng/react-loading-skeleton
 */

const LoadingSkeleton = ({
  baseColor = 'var(--loading-color)',
  highlightColor = 'var(--loading-highlight-color)',
  marginBottom: mB,
  className,
  style,
  ...props
}: LoadingSkeletonProps) => {
  const classes = clsx(mB && typeof mB === 'string' && `marginBottom-${mB}`, className);

  const inlineStyles = {
    marginBottom: mB && typeof mB === 'number' ? `${mB}px` : undefined,
    ...style,
  };

  return (
    <Skeleton
      baseColor={baseColor}
      highlightColor={highlightColor}
      className={classes}
      style={inlineStyles}
      {...props}
    />
  );
};

export default LoadingSkeleton;
